import { createFileRoute } from "@tanstack/react-router";
import AMCReportsListing from "../../../../../views/amc/AMCReportsListing";

export const Route = createFileRoute("/_authenticated/user/amc/conversionchart/reports")({
  component: AMCReportsListing,
  staticData: { application: "Advertising" },
});
